//*************************
//********** GENERAL ********
//*************************

export const DEFAULT_LANGUAGE = 'en'
export const AVAILABLE_LANGUAGES = ['en', 'nl', 'fr', 'de']

export const LANGUAGES = {
    en: { nativeName: 'English', countryCode: 'GB', backendValue: 'en' },
    nl: { nativeName: 'Nederlands', countryCode: 'NL', backendValue: 'nl' },
    fr: { nativeName: 'Français', countryCode: 'FR', backendValue: 'fr' },
    de: { nativeName: 'Deutsch', countryCode: 'DE', backendValue: 'de' },
} as const

export const DOCUMENT_LANGUAGES = [LANGUAGES.fr, LANGUAGES.nl]

export const DEVELOPMENT_MODE = false
